<template>
  <footer class="bg-white sm:bg-transparent absolute w-full bottom-0 left-0 py-3 sm:py-6 border-t border-light-gray">
    <nav class="sm:flex sm:justify-center">
      <ul class="w-full sm:w-auto sm:flex flex-wrap sm:items-center font-thin">
        <li v-if="!isAuthenticated" class="py-1 sm:py-3 bg-white sm:bg-transparent text-center sm:text-left">
          <router-link to="/auth/sign-in" class="text-sm sm:mx-2 md:mx-4 font-normal">
            Sign In
          </router-link>
        </li>
        <span class="hidden sm:block" v-if="!isAuthenticated">|</span>
        <li v-if="!isAuthenticated" class="py-1 sm:py-3 bg-white sm:bg-transparent  text-center sm:text-left">
          <router-link to="/auth/sign-up" class="text-sm sm:mx-2 md:mx-4 font-normal">
            Sign Up
          </router-link>
        </li>
        <span class="hidden sm:block" v-if="!isAuthenticated">|</span>
        <li class="py-1 sm:py-3 bg-white sm:bg-transparent  text-center sm:text-left">
          <router-link to="/how-it-works" class="text-sm sm:mx-2 md:mx-4 font-normal">
            How It Works
          </router-link>
        </li>
        <span class="hidden sm:block">|</span>
        <li class="py-1 sm:py-3 bg-white sm:bg-transparent  text-center sm:text-left">
          <router-link to="/get-in-touch" class="text-sm sm:mx-2 md:mx-4 font-normal">
            Get In Touch
          </router-link>
        </li>
        <span class="hidden sm:block">|</span>

<!--        <li class="py-1 sm:py-3 bg-white sm:bg-transparent  text-center sm:text-left">-->
<!--          <router-link to="/pricing" class="text-sm sm:mx-2 md:mx-4 font-normal">-->
<!--            Pricing-->
<!--          </router-link>-->
<!--        </li>-->
<!--        <span class="hidden sm:block">|</span>-->

<!--        <li class="py-1 sm:py-3 bg-white sm:bg-transparent text-center sm:text-left">-->
<!--          <router-link :to="{name: 'caterer.signup', params: {uuid: 'new'}}" class="text-sm sm:mx-2 md:mx-4 font-normal">-->
<!--            Cater with BuildaBox-->
<!--          </router-link>-->
<!--        </li>-->
<!--        <span class="hidden sm:block">|</span>-->

<!--        <li class="py-1 sm:py-3 bg-white sm:bg-transparent text-center sm:text-left">-->
<!--          <router-link :to="{name: 'event-planner.signup', params: {uuid: 'new'}}" class="text-sm sm:mx-2 md:mx-4 font-normal">-->
<!--            Plan and Support Events with BuildaBox-->
<!--          </router-link>-->
<!--        </li>-->
<!--        <span class="hidden sm:block">|</span>-->
        
<!--        <li class="py-1 sm:py-3 bg-white sm:bg-transparent text-center sm:text-left">-->
<!--          <router-link to="/caterers" class="text-sm sm:mx-2 md:mx-4 font-normal">-->
<!--            Find Caterers-->
<!--          </router-link>-->
<!--        </li>-->
<!--        <span class="hidden sm:block">|</span>-->

        <li class="py-1 sm:py-3 bg-white sm:bg-transparent text-center sm:text-left">
          <router-link to="/privacy-policy" class="text-sm sm:mx-2 md:mx-4 font-normal">
            Privacy Policy
          </router-link>
        </li>
        
      </ul>
    </nav>
  </footer>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "Footer",
    computed: {
      ...mapGetters(['isAuthenticated'])
    }
  }
</script>

<style scoped>
</style>
